import NoImageIcon from './component'

export default NoImageIcon
